// extracted by mini-css-extract-plugin
export default {"button":"styles_button__i384H","card":"styles_card__PlsKJ","link":"styles_link__8loTU"};